import type { Control } from "react-hook-form";
import { ClientPortfolioDomainEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { InvestmentAdditionalFields } from "web_myplann/Portfolio/Forms/InvestmentForm/InvestmentAdditionalFields";
import { InvestmentBasicFields } from "web_myplann/Portfolio/Forms/InvestmentForm/InvestmentBasicFields";
import { InvestmentToolsSection } from "web_myplann/Portfolio/Forms/InvestmentForm/InvestmentToolsSection";
import type {
	InvestmentEditFormInput,
	InvestmentEditFormOutput,
} from "web_myplann/Portfolio/Forms/InvestmentForm/investmentFormSchema";

type InvestmentEditFormFieldsProps = {
	control: Control<InvestmentEditFormInput, unknown, InvestmentEditFormOutput>;
	disableKeyFields?: boolean;
};

export const InvestmentEditFormFields = ({
	control,
	disableKeyFields,
}: InvestmentEditFormFieldsProps) => {
	const { t } = useResource();

	return (
		<>
			<InvestmentBasicFields
				control={control}
				disableKeyFields={disableKeyFields}
				domain={ClientPortfolioDomainEnum.Investments}
				namePlaceholder={t(Resources.Portfolio.AddInvestment.Placeholders.name)}
			/>
			<InvestmentToolsSection control={control} mergeDuplicateIsin />
			<InvestmentAdditionalFields
				control={control}
				disableKeyFields={disableKeyFields}
			/>
		</>
	);
};
